/*
 * Module module for the Employer Association's Reporting Agency View
*/

rs.module("content/employer/account/associations/reportingagency",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl) {

            var form = $.js(jsSelectors.form);

            // 
            form.js(jsSelectors.fundSelect, { required: false }).change(function () {

                selectHelper.getHelper(form.js(jsSelectors.reportingAgencySelect, { required: false })).loadOptionsFrom(
                    backendUrl,
                    {
                        fundKey: $(this).val()
                    },
                    {
                        withBlank: true
                    });
            });

        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);